export default __webpack_public_path__ + "static/media/post_campaign-banner-desktop.4debf06b.jpg";